import React from 'react';

/**
 * Floating upload status card — shown during and after any upload/download.
 * status: 'uploading' | 'processing' | 'done' | 'error'
 */
export default function UploadToast({ label, status, progress, detail, onClose }) {
  const colors = {
    uploading:  'var(--primary)',
    processing: 'var(--warning)',
    done:       'var(--success)',
    error:      'var(--error)',
  };
  const icons = {
    uploading:  '⬆️',
    processing: '⚙️',
    done:       '✅',
    error:      '❌',
  };

  const color = colors[status] || 'var(--primary)';
  const icon  = icons[status]  || '⏳';
  const isDone = status === 'done' || status === 'error';
  const isIndeterminate = progress === -1;

  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
      background: 'var(--surface)', border: `1px solid ${color}`,
      borderRadius: 'var(--radius)', padding: '14px 18px',
      minWidth: 280, maxWidth: 360,
      boxShadow: `0 8px 32px rgba(0,0,0,.4), 0 0 0 1px ${color}33`,
      animation: 'slideUp .25s ease',
    }}>
      <style>{`@keyframes slideUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}`}</style>

      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom: isDone ? 0 : 10 }}>
        <span style={{ fontSize:'1.2rem' }}>{icon}</span>
        <div style={{ flex:1 }}>
          <div style={{ fontWeight:700, fontSize:'.88rem', color:'var(--text)' }}>{label}</div>
          {detail && <div style={{ fontSize:'.78rem', color:'var(--text-muted)', marginTop:2 }}>{detail}</div>}
        </div>
        {isDone && onClose && (
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--text-muted)', fontSize:'.9rem', padding:'2px 6px', borderRadius:4 }}>✕</button>
        )}
      </div>

      {!isDone && (
        <div style={{ background:'var(--bg3)', borderRadius:99, height:5, overflow:'hidden' }}>
          {isIndeterminate ? (
            <div style={{
              height:'100%', width:'40%', background:`linear-gradient(90deg,transparent,${color},transparent)`,
              borderRadius:99, animation:'shimmer 1.5s infinite',
            }}/>
          ) : (
            <div style={{
              height:'100%', width:`${progress}%`,
              background: `linear-gradient(90deg,${color},${color}cc)`,
              borderRadius:99, transition:'width .3s',
            }}/>
          )}
        </div>
      )}
      {!isDone && !isIndeterminate && (
        <div style={{ fontSize:'.74rem', color:'var(--text-muted)', marginTop:4, textAlign:'right' }}>
          {progress}%
        </div>
      )}

      <style>{`
        @keyframes shimmer {
          0%   { transform: translateX(-150%) }
          100% { transform: translateX(350%) }
        }
      `}</style>
    </div>
  );
}
